// extracted by mini-css-extract-plugin
export var hero = "hero-module--hero--8tnzb";
export var hero__title = "hero-module--hero__title--K181a";
export var hero__media = "hero-module--hero__media--031ib";
export var hero__gradient = "hero-module--hero__gradient--w9HNm";
export var hero__gradient_laptop = "hero-module--hero__gradient_laptop--yiUUG";
export var hero__gradient_tablet = "hero-module--hero__gradient_tablet--kdc8I";
export var hero__gradient_mobile = "hero-module--hero__gradient_mobile--rLXBA";
export var hero_textLeft = "hero-module--hero_text-left--r0Dih";
export var hero__button = "hero-module--hero__button--gjM-U";
export var hero__gradient_desktop = "hero-module--hero__gradient_desktop--qENUF";